import { gql } from '@apollo/client'

import type { SectionName } from '@/lib/apollo/query/get-document-requests'

export enum IdentityRequestType {
  CompleteIdVerification = 'CompleteIdVerification',
  CompleteIdVerificationImageQuality = 'CompleteIdVerificationImageQuality',
  CompleteIdVerificationPartialImage = 'CompleteIdVerificationPartialImage',
  CompleteIdVerificationUnsupportedDocument = 'CompleteIdVerificationUnsupportedDocument',
  CompleteIdVerificationFaceCheckRetry = 'CompleteIdVerificationFaceCheckRetry',
}

export const IDENTITY_RECOMMENDATION_TYPE = 'IDVTRecommendation'

export type MutationVars = {
  customerId: string
  subjectId: string
  personId: string
  requestSubject: string
  requestMessage: string
  recommendationType: typeof IDENTITY_RECOMMENDATION_TYPE
  requestType: IdentityRequestType
  documentSection: SectionName
  agentComment: string
  internalComment: string
}

export type Response = {
  createDataRequest: string
}

const mutation = gql`
  mutation createIdentityDataRequest(
    $customerId: String!
    $subjectId: String!
    $personId: String!
    $requestSubject: String!
    $requestMessage: String!
    $recommendationType: String!
    $requestType: IdentityRequestType!
    $documentSection: DocumentRequestSectionType!
    $agentComment: String
    $internalComment: String
  ) {
    createDataRequest(
      customerId: $customerId
      subjectId: $subjectId
      personId: $personId
      requestSubject: $requestSubject
      requestMessage: $requestMessage
      recommendationType: $recommendationType
      requestType: $requestType
      documentSection: $documentSection
      agentComment: $agentComment
      internalComment: $internalComment
    )
  }
`

export default mutation
